<div class="w-[450px] p-3" (click)="$event.stopPropagation()">
    @if (userProfile$ | async; as user) {
        <div class="flex flex-row items-center gap-6 px-2 py-2">
            <div
                class="flex h-16 w-16 flex-none items-center justify-center overflow-hidden rounded-full bg-[var(--scf-primary)] font-semibold text-[var(--scf-text)]"
            >
                @if (userPhotoUrl()) {
                    <img [src]="userPhotoUrl()" [alt]="user.displayName" class="h-full w-full object-cover" />
                } @else {
                    {{ user.initials }}
                }
            </div>
            <div class="flex min-w-0 flex-col">
                <h3 class="m-0 truncate text-[1.1rem] leading-snug font-semibold">{{ user.displayName }}</h3>
                <p class="m-0 truncate text-sm leading-tight text-text-secondary">{{ user.department }}</p>
                <p class="m-0 truncate text-xs leading-tight text-text-secondary">{{ user.mail }}</p>
            </div>
        </div>
    } @else {
        {{ 'header-profile-selector-no-active-user' | translate }}
    }
    <div class="mt-4 mb-3 flex flex-row justify-between">
        <div>
            @if ((currentUser$ | async)?.role === userRoles.ADMIN) {
                <div class="form-check form-switch">
                    <input
                        type="checkbox"
                        class="form-check-input"
                        role="switch"
                        id="adminToggle"
                        [checked]="isAdmin$ | async"
                        (change)="isAdminChanged($event)"
                    />
                    <label for="adminToggle" class="form-check-label">{{
                        'header-profile-selector-adminmode' | translate
                    }}</label>
                </div>
            }
        </div>
    </div>
    <hr />
    <h4 class="m-0 ml-3 text-[1.2em] text-text-primary">
        {{ 'header-profile-selector-profiles-header' | translate }}
    </h4>
    @if (profiles$ | async | sort: 'displayName' : 'id'; as profiles) {
        @for (profile of profiles; track profile.id) {
            <button
                type="button"
                class="flex w-full cursor-pointer flex-row items-center gap-4 rounded-sm border-0 bg-transparent p-4 pl-3 text-left transition-colors hover:bg-base-1-hover"
                [class.bg-base-1-selected]="profile.id === currentProfileId"
                [attr.aria-label]="'Select profile ' + profile.displayName"
                (click)="selectProfile(profile)"
            >
                <div
                    class="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-[var(--element-action-primary)] text-xs font-semibold text-[var(--element-action-primary-text)]"
                >
                    {{ profile.initials }}
                </div>
                <div class="flex min-w-0 flex-col">
                    <p class="m-0 truncate text-sm leading-tight">{{ profile.displayName }}</p>
                    <p class="m-0 truncate text-xs leading-tight text-text-secondary">{{ profile.department }}</p>
                </div>
            </button>
        }
    } @else {
        {{ 'header-profile-selector-no-profiles' | translate }}
    }
    <div class="mt-4 flex flex-row justify-center">
        <button type="button" class="btn btn-secondary" [routerLink]="['/profiles']" (click)="closeMenu()">
            {{ 'header-profile-selector-to-profiles-button' | translate }}
        </button>
    </div>
</div>
